<template>
  <div class="dialog-container wt-dialog-container">
    <div>
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm">
        <template slot="garbageImg">
          <template v-if="detailFormData.garbageImg && detailFormData.garbageImg.length > 0">
              <el-image
                style="width: 100px; height: 100px;"
                v-for="(item, index) in detailFormData.garbageImg.split(',')"
                :src="imgUrl + item"
                :z-index="999"
                fit="cover"
                :key="index"
                :preview-src-list="[imgUrl + item]"></el-image>
          </template>
        </template>
        <template slot="history">
          <div class="delivery-history">
            <div class="wt-tab-info-card" v-for="item in historyData" :key="item.id">
              <div class="wt-tab-info-content wt-tab-base">
                <div class="wt-tab-base-item">
                  <span class="wt-tab-base-label">修改人：</span>
                  <span class="wt-tab-base-value">{{ item.changeUserName }}</span>
                </div>
                <div class="wt-tab-base-item">
                  <span class="wt-tab-base-label">修改时间：</span>
                  <span class="wt-tab-base-value">{{ item.changeTime }}</span>
                </div>
                <div class="wt-tab-base-item">
                  <span class="wt-tab-base-label">物品名称：</span>
                  <span class="wt-tab-base-value">{{ item.garbageName }}</span>
                </div>
                <div class="wt-tab-base-item">
                  <span class="wt-tab-base-label">投递总量（kg）：</span>
                  <span class="wt-tab-base-value">{{ item.garbageWeight }}</span>
                </div>
                <div class="wt-tab-base-item wt-tab-base-item-long">
                  <span class="wt-tab-base-label">调整原因：</span>
                  <span class="wt-tab-base-value">{{ item.changeReason }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </wt-detail-form-section>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'DeliveryHomeApplianceEdit',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      formCode: 'MODULES_GARBAGEDELIVERYTYPE',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/userDeliveryOther/updateuUserDeliveryOther',
      detailFormButtons: {
        title: '详情',
        elements: [{ name: '提交', key: 'ADD', action: 'ADD', className: 'primary', hidden: this.componentType !== 'add' },
          { name: '提交', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: this.componentType !== 'edit' },
          { name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '投递信息',
        className: 'wt-section-long-content',
        elements: [
          { name: '用户昵称', key: 'nickName', type: 'text', disabled: true, className: 'wt-col-12' },
          { name: '手机号', key: 'phone', type: 'text', disabled: true, className: 'wt-col-12' },
          { name: '物品名称', key: 'garbageTypeId', type: 'select', disabled: true, required: true, data: [], className: 'wt-col-12' },
          { name: '投递总量（个）',
            key: 'garbageCount',
            type: 'text',
            disabled: true,
            required: true,
            className: 'wt-col-12',
            rules: [
              { validator: this.$wtValidator.ValidatorGreaterZeroInt, message: '请输入不小于0的整数', trigger: 'blur' }
            ] },
          { name: '总积分(个)', key: 'garbageTotalPrice', type: 'text', disabled: true, className: 'wt-col-12' },
          { name: '社区', key: 'communityName', type: 'text', disabled: true, className: 'wt-col-12' },
          { name: '站点', key: 'siteName', type: 'text', disabled: true, className: 'wt-col-12' },
          { name: '投递时间', key: 'createTime', type: 'text', disabled: true, className: 'wt-col-12' },
          { name: '操作人员', key: 'employeesUserName', type: 'text', disabled: true, className: 'wt-col-12' },
          { name: '货物图片', key: 'garbageImg', type: 'custom', disabled: true, className: 'wt-col-12' },
          { name: '调整原因', key: 'changeReason', type: 'textarea', disabled: true, className: 'wt-col-12' },
          { name: '', key: 'history', type: 'customAll', disabled: true, className: 'wt-col-12' }]
      },
      historyData: []
    }
  },
  created() {
    this.initPage()
  },
  methods: {
    initPage() {
      this.$store.dispatch('queryGarbageDeliveryTypeListNoPage', 2).then(res => {
        this.detailForm.elements[2].data = res
      })
      this.$store.dispatch('appendBreadcrumb', { meta: { title: this.componentType === 'edit' ? '编辑' : '查看' }})
      if (this.componentType === 'edit') {
        this.detailForm.elements[2].disabled = false
        this.detailForm.elements[3].disabled = false
        // this.detailForm.elements[4].disabled = false
        this.detailForm.elements[10].disabled = false
      } else {
        // this.$api.delivery.userDeliveryGarbageHistoryList({
        //   id: this.detailFormData.id
        // }).then(res => {
        //   this.historyData = res.data
        // })
      }
    },
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
      } else if (item.action === 'EDIT') {
        this.onSave()
      }
    },
    onSave() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestUpdate()
      }).catch(() => {
      })
    },
    /*  ------------------------- 网络请求  -------------------------  */
    requestUpdate() {
      const that = this
      const sendData = {
        changeReason: this.detailFormData.changeReason,
        garbageCount: this.detailFormData.garbageCount,
        garbageTypeId: this.detailFormData.garbageTypeId,
        id: this.detailFormData.id
      }
      this.$wtUtil.postFormData({
        url: this.formUpdateUrl,
        formData: sendData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
        that.$emit('on-dialog-action', 'refresh')
        that.$store.dispatch('removeBreadcrumb')
      })
    },
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      detailFormData: state => state.garbageDeliveryType.otherGarbageDetailData
    }),
    garbagePrice() {
      let p = 0
      for (const item of this.detailForm.elements[2].data) {
        if (item.value === this.detailFormData.garbageTypeId) {
          p = item.integral
        }
      }
      return p
    }
  },
  watch: {
    'detailFormData.garbageCount'(val) {
      if (this.$wtUtil.isGreaterZeroInt(val)) {
        this.detailFormData.garbageTotalPrice = val * this.garbagePrice
      }
    },
    'detailFormData.garbageTypeId'(val) {
      if (this.$wtUtil.isGreaterZeroInt(this.detailFormData.garbageCount)) {
        this.detailFormData.garbageTotalPrice = this.detailFormData.garbageCount * this.garbagePrice
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.delivery-history {
  font-size: 14px;
  .wt-tab-info-card {
    & + .wt-tab-info-card {
      margin-top: 0;
    }
    border-top: 1px solid #e4e4e4;
    .wt-tab-base .wt-tab-base-label {
      width: 150px;
    }
    .wt-tab-info-content {
      padding-bottom: 0;
    }
  }
}
</style>
